import React from 'react'
import './Map.css'
import {MapContainer as LeafletMap, TileLayer, Marker, Popup, useMap, Circle,CircleMarker} from 'react-leaflet'
// import {ChangeView} from './ChangeView'

const ChangeView = ({ center, zoom }) => {
    const map = useMap();
    map.setView(center, zoom);
    return null;
}

function Map({ center, zoom, countries, caseType }) {
    const caseTypeColors = {
        cases:{
            color:"#CC1034"
        },
        recovered:{
            color:"#7dd71d"
        },
        deaths:{
            color:"#fb4443"
        }
    }

    const caseMultipliers = {
        cases:".02",
        recovered:".021",
        deaths:".09"
    }

    // const redOptions = { color: 'red' }'

    return (
        <div class="map">
            <LeafletMap center={center} zoom={zoom} scrollWheelZoom={true}>
            <ChangeView center={center} zoom={zoom} /> 
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {/**loop throught data to get cirlces on map */}
                {
                    countries.map((country) => (
                        <CircleMarker 
                            key={country.country} 
                            center={[country.countryInfo.lat, country.countryInfo.long]} 
                            pathOptions={caseTypeColors[caseType]} 
                            radius={ Math.sqrt(country[caseType]) * caseMultipliers[caseType]} >
                            <Popup>
                                <div 
                                    className="info-flag" 
                                    style={{backgroundImage: `url(${country.countryInfo.flag})`}}></div>
                                <label style={{fontSize:`15px`, fontWeight:`bold`}}>{country.country}</label><br/>
                                <label>Total Cases:{country.cases}</label><br/>
                                <label>Today's Cases:{country.todayCases}</label><br/>
                                <label>Recovered:{country.recovered}</label><br/>
                                <label>Deaths:{country.deaths}</label>
                            </Popup>
                        </CircleMarker>
                    ))
                }

            {/*<Marker position={center}>
            <Popup>
                A pretty CSS3 popup. <br /> Easily customizable.
            </Popup>
            </Marker>*/}
            </LeafletMap>
        </div>
    )
}

export default Map
